import * as React from 'react'
import RequestParameters from "./requestParameters";
import {useTranslation} from "gatsby-plugin-react-i18next";
import EnumParameter from "./enumParameter";
import NumberParameter from "./numberParameter";

const VideoOptions = (props) => {
    const {t} = useTranslation();
    const [duration, setDuration] = React.useState(null)
    const [transition, setTransition] = React.useState(null)
    const [transitionType, setTransitionType] = React.useState(null)
    const [resolutionType, setResolutionType] = React.useState(null)


    React.useEffect(() => {
        if (props.disable)
            return;
        const options = [];
        transitionType !== null && transitionType !== "" && options.push({
            key: "transitionType",
            value: `"${transitionType}"`
        });
        resolutionType !== null && resolutionType !== "" && options.push({
            key: "resolutionType",
            value: `"${resolutionType}"`
        });
        duration !== null && duration !== "" && options.push({key: "duration", value: duration});
        transition !== null && transition !== "" && options.push({key: "transition", value: transition});
        props.onChange(options)
    }, [duration, transition, resolutionType, transitionType])


    return (
        <RequestParameters disable={props.disable}>
            <NumberParameter
                type="int32"
                value={duration === null ? "" : duration}
                parameter="duration"
                description={t("video-duration")}
                onChange={((e) => setDuration(e.target.value))}
                disable={props.disable}/>
            <NumberParameter
                type="int32"
                value={transition === null ? "" : transition}
                parameter="transition"
                description={t("video-transition")}
                onChange={((e) => setTransition(e.target.value))}
                disable={props.disable}/>
            <EnumParameter
                values={["None", "Random", "FromPresentation", "Fade", "Distance", "SlideLeft", "CircleCrop", "Dissolve"]}
                type="VideoTransitionType"
                parameter="transitionType"
                description={t("video-transition-type")}
                onChange={((e) => setTransitionType(e.target.value))}
                disable={props.disable}/>
            <EnumParameter
                values={["SD", "HD", "FullHD", "QHD"]}
                type="VideoResolutionType"
                parameter="resolutionType"
                description={t("video-resolution-type")}
                onChange={(e) => {setResolutionType(e.target.value)}}
                disable={props.disable}/>
        </RequestParameters>
    );
}

export default VideoOptions;